import http from 'conversations-http/clients/http';
export const fetchInboxesClient = () => {
  return http.get('/messages/v2/inbox/all');
};